import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { ctaFragment, imageFragment } from 'bundles/ent-website/queries/common';

export const entWebsiteUpcomingEventCardFragment = contentfulGql`#graphql
  ${ctaFragment}
  ${imageFragment}
  fragment EntWebsiteUpcomingEventCard on EntWebsiteUpcomingEventCard {
    sys {
      id
    }
    headline
    eyebrow
    image {
      ...Image
    }
    cta {
      ...Cta
    }
  }
`;

export const entWebsiteUpcomingEventsFragment = contentfulGql`#graphql
  ${ctaFragment}
  ${entWebsiteUpcomingEventCardFragment}
  fragment EntWebsiteUpcomingEvents on EntWebsiteUpcomingEvents {
    slug
    headerTitle
    headerCta {
      ...Cta
    }
    upcomingEventsCollection {
      items {
        ...EntWebsiteUpcomingEventCard
      }
    }
  }
`;

export const entWebsiteBlockUpcomingEventsQuery = contentfulGql`#graphql
${entWebsiteBlockAssemblyFragment}
${entWebsiteUpcomingEventsFragment}

   query entWebsiteBlockUpcomingEvents($id: String!, $preview: Boolean, $locale: String!) {
     entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
       ...EntWebsiteBlockAssembly
       reference {
         __typename
        ...EntWebsiteUpcomingEvents
       }
     }
   }
`;
